import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ParameterService } from '../../services/parameter/parameter.service';
import { Option } from '../../../ui-components/core-dropdown/core-dropdown.component';
import { catchError, forkJoin, of } from 'rxjs';
import { CorePopupComponent } from '../../../ui-components/core-popup/core-popup.component';
import { GetPriceSummaryKDV } from '../../../pages/prices/interfaces/interfaces';
import { AppMessageService } from '../../services/app-message/app-message.service';

@Component({
  selector: 'app-change-kdv-rates',
  templateUrl: './change-kdv-rates.component.html',
  styleUrl: './change-kdv-rates.component.scss',
})
export class ChangeKdvRatesComponent implements OnInit {
  @ViewChild('corePopup') corePopup: CorePopupComponent;
  @Output() closeOn = new EventEmitter();
  @Output() continueOn = new EventEmitter();
  @Output() saveOn = new EventEmitter();
  kdvRates: GetPriceSummaryKDV[] = [];

  allKDVRate: Option[] = [];
  visible: boolean = false;

  constructor(
    private readonly parameterService: ParameterService,
    private readonly messageService: AppMessageService
  ) {}

  ngOnInit() {
    forkJoin({
      kdvRates: this.parameterService
        .getValues('data-group', 'kdv-rates')
        .pipe(catchError(() => of(null))),
    }).subscribe((results) => {
      this.allKDVRate =
        results?.kdvRates?.datas?.values?.map((data: any) => {
          return {
            label: data?.valueObject?.name?.value,
            value: data?.valueObject?.id?.value,
            disabled: !data?.valueObject?.status?.value,
          };
        }) ?? [];
    });
  }

  initilize(kdvRates: GetPriceSummaryKDV[]) {
    this.kdvRates = kdvRates ?? [];
    this.corePopup.openDialog();
  }
  closePopup() {
    this.visible = false;
    this.closeOn.emit();
  }
  continueF() {
    const hasNull = this.kdvRates.find((r) => !r?.newKdvRateId);

    if (hasNull) {
      this.messageService.warningToast('Uyarı', 'Yeni Kdv Oranı boş olamaz!');
      return;
    }

    this.kdvRates = this.kdvRates.map((e) => {
      return {
        ...e,
        newKdvRateLabel:
          this.allKDVRate.find((rate) => rate.value === e.newKdvRateId)
            ?.label ?? '',
      };
    });
    this.continueOn.emit(this.kdvRates);
  }

  openApprovePopup(kdvRates: GetPriceSummaryKDV[]) {
    this.kdvRates = kdvRates;
    this.visible = true;
  }
  cancelVisible() {
    this.visible = false;
  }
  save() {
    this.saveOn.emit(this.kdvRates);
  }
}
